export default import.meta.ROLLUP_FILE_URL_8G8Zqc3TRtDnPedLpio3ow